export const environment = {
  production: true,
  apiUrlBase: 'https://fitur2026b.ciceroneweb.com',
  urlImmersive: 'https://fitur2026e.ciceroneweb.com',
  urlWebSocket: 'wss://pre.gpt.cms-iurban.com/ws/assistant',
  urlWebSocketTools: 'wss://pre.gpt.cms-iurban.com/ws/assistant/tool-feedback',
  urlChatHistory: 'https://pre.gpt.cms-iurban.com/get_conversation',
  urlTextToSpeech: 'https://pre.gpt.cms-iurban.com/tts/stream',
  urlWelcomeMessage: 'https://pre.gpt.cms-iurban.com/fitur/presentation',
  urlGetSaturated: 'https://pre.gpt.cms-iurban.com/fitur/get-saturated-information',
  urlGetProfiledRouteInfo: 'https://pre.gpt.cms-iurban.com/fitur/user-profile',
  
  //urlWebSocket: 'wss://dev.gpt.cms-iurban.com/ws/assistant',
  //urlWebSocketTools: 'wss://dev.gpt.cms-iurban.com/ws/assistant/tool-feedback',
  //urlChatHistory: 'https://dev.gpt.cms-iurban.com/get_conversation',
  //urlTextToSpeech: 'https://dev.gpt.cms-iurban.com/tts/stream',
  //urlWelcomeMessage: 'https://dev.gpt.cms-iurban.com/fitur/presentation',
  //urlGetSaturated: 'https://dev.gpt.cms-iurban.com/fitur/get-saturated-information',
  //urlGetProfiledRouteInfo: 'https://dev.gpt.cms-iurban.com/fitur/user-profile',
  
  // websocket-laravel-reverb configuration
  reverb: {
      // Host del servidor WebSocket
      host: 'wsiurban.ageofspace.net',

      // Puerto: 443 para WSS a través de Nginx en Forge
      port: 443,

      // Esquema: siempre 'wss' en producción
      scheme: 'wss' as 'ws' | 'wss',

      // Credenciales de la aplicación Reverb (obtener del .env del backend)
      appKey: 'xipmjzddgjiyyzkxssen',

      // Cluster (puede ser cualquier valor para Reverb)
      cluster: 'mt1',
  },
  // URL base de la API Laravel (puede ser diferente del host WS)
  apiUrlWebsocket: 'https://wsiurban.ageofspace.net/api',
};
